export const API_URL = 'https://EndPointTesting.aud.edu';
//  export const API_URL = "https://audapitesting.ctsdemo.ae";

export const US_ID = 'aa4e5cd3-8ff3-401a-a6f4-94d8baedce2d';
export const Emirates_ID = 'dcb9b21c-31bf-42fa-9b60-fab3608a49e6';
